<template>
    <span
        class="text-succes float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9">
        <i
            class="fa fa-retweet fa-lg icon-button"
            title="Resetar Situação da Prestação"
            @click.stop="confirmarReset(prestacaoContasFinalLancamento.idPrestacaoContasFinal)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {

    props: {
        convenio: Object,
        prestacaoContasFinalLancamento: Object,
    },

    methods: {
        confirmarReset(id){
            this.$swal({
                title: 'Resetar',
                html: 'Deseja Resetar a situação da Prestação ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.resetar(id)
                }
            })
        },

        resetar(id){
            this.$store.dispatch('addRequest')
            ConveniosServicos.resetarPrestacaoContasFinal(id)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Situação resetada com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                        this.$emit('ocorreuAlteracao')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
}
</script>
